<template>
<div>
  <form @submit.prevent="submit">
    <b-row>

      <b-col sm="6">
        
        <b-form-group label="Exportadora">
          <b-form-select
            :state="$v.boarding.exporter_company.$dirty ? !$v.boarding.exporter_company.$error : null"
            v-model="$v.boarding.exporter_company.$model"
            :options="exporter_companys"/>
        </b-form-group>
         
        <b-form-group label="Agente Aduanas">
          <b-form-select
            :state="$v.boarding.custom_agent_company.$dirty ? !$v.boarding.custom_agent_company.$error : null"
            v-model="$v.boarding.custom_agent_company.$model"
            :options="custom_agent_companys"/>
        </b-form-group>
      </b-col>

       <b-col sm="6">
         <b-form-group label="Embarcador">
          <b-form-select
            :state="$v.boarding.shipper_company.$dirty ? !$v.boarding.shipper_company.$error : null"
            v-model="$v.boarding.shipper_company.$model"
            :options="shipper_companys"/>
        </b-form-group>

        <b-form-group label="Consignatario">
          <b-form-select
            :state="$v.boarding.consignee_company.$dirty ? !$v.boarding.consignee_company.$error : null"
            v-model="$v.boarding.consignee_company.$model"
            :options="consignee_companys"/>
        </b-form-group>
      </b-col>

       <b-col sm="6">
         <b-form-group label="Notificador">
          <b-form-select
            :state="$v.boarding.notify_company.$dirty ? !$v.boarding.notify_company.$error : null"
            v-model="$v.boarding.notify_company.$model"
            :options="notify_companys"/>
        </b-form-group>
      </b-col>

        <b-col sm="6">
       <b-form-group label="Planta">
          <b-form-select
            :state="$v.boarding.plant.$dirty ? !$v.boarding.plant.$error : null"
            v-model="$v.boarding.plant.$model"
            :options="plants"/>
        </b-form-group>

     

        
      </b-col>
    </b-row>
  </form>
  </div>
</template>

<script>

  import {required, numeric, minLength, between} from 'vuelidate/lib/validators'

  export default {
    name: "formEmpresas",
    props: [
      'boarding'
    ],
    data() {
      return {
        exporter_companys: [],
        custom_agent_companys: [],
        shipper_companys: [],
        consignee_companys: [],
        notify_companys: [],
        plants: [],
  
      }
    },
    validations: {
      boarding: {
        custom_agent_company: {required},
        exporter_company: {required},
        shipper_company: {required},
        consignee_company: {required},
        notify_company: {required},
        plant: {required},
        
      
      }
    },
    mounted () {
      this.loadDataForm();
    },
    methods: {
      saveForm(){
       this.$v.$touch();
      if (this.$v.$invalid) {
        return 0;
      } else {
        return 1;
      }
      },
      loadDataForm(){
      
       this.$axios.get ('/api/comex/companyform/get_select_company/', {
          params: {
          client: this.$store.getters.user.ID_CLIENTE
          }
          })
        .then(res => {

          this.exporter_companys = res.data.exporter_company_list;
          this.exporter_companys.unshift({value: '', text: 'Seleccione'})
          
          this.custom_agent_companys = res.data.customs_agency_list;
          this.custom_agent_companys.unshift({value: '', text: 'Seleccione'})

          this.shipper_companys = res.data.shipper_company_list;
          this.shipper_companys.unshift({value: '', text: 'Seleccione'})

          this.consignee_companys = res.data.consignee_company_list;
          this.consignee_companys.unshift({value: '', text: 'Seleccione'})

          this.notify_companys = res.data.notify_company_list;
          this.notify_companys.unshift({value: '', text: 'Seleccione'})

          this.plants = res.data.plant_list;
          this.plants.unshift({value: '', text: 'Seleccione'})

   

        })
       .catch(error => {
          console.log(error.response)
        });

      },
      submit() {
      },
    },
    beforeMount() {
      
    },
  }

</script>

<style scoped>

</style>
